import { useEffect } from 'react';
import { useAuthStore } from '../../stores';
import ErrorView from './ErrorView';
import { PublicOff } from '@mui/icons-material';

function DomainNotFound() {
  useEffect(() => {
    useAuthStore.getState().signOutLocal();
  }, []);

  return (
    <ErrorView
      title="Site not found"
      heading="Site not found"
      message="Check the address entered. New sites may take a few minutes to appear. If the issue persists, contact your pool service provider."
      buttonText="Try Again"
      icon={PublicOff}
    />
  );
}

export default DomainNotFound;
